// extracted by mini-css-extract-plugin
export default {"wrapper":"Accordion_wrapper__kupx1","title":"Accordion_title__5m-v8","content":"Accordion_content__t93-E"};